import {
  BarChartSplit,
  Exposure,
  List,
  PlayingCards,
  Public,
  Thumbnails
} from "@wix/wix-ui-icons-common";
import React from "react";
const WIDGET_TYPE_OPTIONS = [
  {
    id: "widget-type-1",
    label: "Chart",
    icon: /* @__PURE__ */ React.createElement(BarChartSplit, null)
  },
  {
    id: "preset-2",
    label: "Infographic",
    icon: /* @__PURE__ */ React.createElement(Thumbnails, null)
  },
  {
    id: "preset-3",
    label: "Game",
    icon: /* @__PURE__ */ React.createElement(PlayingCards, null)
  },
  {
    id: "preset-4",
    label: "Map",
    icon: /* @__PURE__ */ React.createElement(Public, null)
  },
  {
    id: "preset-5",
    label: "Calculator",
    icon: /* @__PURE__ */ React.createElement(Exposure, null)
  },
  {
    id: "preset-6",
    label: "Shopping List",
    icon: /* @__PURE__ */ React.createElement(List, null)
  }
];
export {
  WIDGET_TYPE_OPTIONS
};
//# sourceMappingURL=common.js.map
